<template>
  <header class="header">
    <div class="bg-blue-700 py-2">
      <div class="container flex justify-between items-center">
        <div class="text-white text-sm">
          您好,欢迎您来到吉林省软件行业协会！当前访问量：{{ visitorCount }}
        </div>
        <div class="flex items-center space-x-4">
<!--          <template v-if="isLoggedIn">-->
<!--            <div-->
<!--              class="user-avatar relative"-->
<!--              @mouseenter="showDropdown"-->
<!--              @mouseleave="hideDropdownWithDelay"-->
<!--            >-->
<!--              <button-->
<!--                class="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity"-->
<!--                @click="goToUserConsole"-->
<!--                title="用户控制台"-->
<!--              >-->
<!--                <i class="fa fa-user text-gray-600"></i>-->
<!--              </button>-->
<!--              <div-->
<!--                v-show="showUserDropdown"-->
<!--                class="absolute right-0 mt-1 w-48 bg-white rounded-lg shadow-lg py-2 z-10 user-dropdown"-->
<!--                @mouseenter="showDropdown"-->
<!--                @mouseleave="hideDropdownWithDelay"-->
<!--              >-->
<!--                <button class="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100" @click="goToUserConsole">用户控制台</button>-->
<!--                <button class="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100" @click="handleLogout">登出</button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </template>-->
<!--          <template>-->
<!--            <button class="btn-primary" @click="handleLogin">登录</button>-->
<!--          </template>-->
        </div>
      </div>
    </div>
    <div class="container">
      <div class="flex flex-wrap md:flex-nowrap items-center justify-between py-4">
        <router-link to="/" class="flex items-center gap-2 md:gap-3 mb-2 md:mb-0 cursor-pointer hover:opacity-80 transition-opacity">
            <img src="../assets/logo1.png" alt="logo" class="hidden md:block w-10 h-10 lg:w-12 lg:h-12 object-contain flex-shrink-0">
            <h1 class="hidden md:block text-gray-800 font-bold tracking-wider whitespace-nowrap flex-shrink-0" style="font-size: clamp(1rem, 1.8vw, 1.375rem);">吉林省软件行业协会</h1>
            <img src="../assets/logo.png" alt="吉林省软件行业协会" class="block md:hidden h-10 object-contain">
        </router-link>

        <!-- 移动端菜单按钮 -->
        <button
          class="md:hidden text-gray-700 text-2xl p-2"
          @click="toggleMobileMenu"
        >
          <i :class="mobileMenuOpen ? 'fa fa-times' : 'fa fa-bars'"></i>
        </button>

        <!-- 桌面端导航 -->
        <nav class="flex-1 hidden md:flex justify-end items-center space-x-2 lg:space-x-5 my-2 md:my-0">
          <a href="#about" class="nav-item" @click="goToAbout">关于协会</a>
          <a href="#news" class="nav-item" @click="goToNews">协会动态</a>
          <a href="#services" class="nav-item" @click="goToServices">服务项目</a>
          <a href="#branches" class="nav-item" @click="goToBranches">分支机构</a>
          <a href="#members" class="nav-item" @click="goToMembers">会员风采</a>
          <a href="#contact" class="nav-item" @click="goToContact">联系协会</a>
            <button class="btn-primary" @click="handleLogin" style="padding: 4px 15px;">登录</button>
        </nav>

      </div>

      <!-- 移动端导航菜单 -->
      <div
        v-if="mobileMenuOpen"
        class="md:hidden bg-white shadow-lg rounded-lg p-4 mb-4"
      >
        <nav class="flex flex-col space-y-2">
          <a
            href="#about"
            class="block py-2 px-4 text-gray-700 hover:bg-primary/10 rounded"
            @click="goToAbout; mobileMenuOpen = false"
          >关于协会</a>
          <a
            href="#news"
            class="block py-2 px-4 text-gray-700 hover:bg-primary/10 rounded"
            @click="goToNews; mobileMenuOpen = false"
          >协会动态</a>
          <a
            href="#services"
            class="block py-2 px-4 text-gray-700 hover:bg-primary/10 rounded"
            @click="goToServices; mobileMenuOpen = false"
          >服务项目</a>
          <a
            href="#branches"
            class="block py-2 px-4 text-gray-700 hover:bg-primary/10 rounded"
            @click="goToBranches; mobileMenuOpen = false"
          >分支机构</a>
          <a
            href="#members"
            class="block py-2 px-4 text-gray-700 hover:bg-primary/10 rounded"
            @click="goToMembers; mobileMenuOpen = false"
          >会员风采</a>
          <a
            href="#contact"
            class="block py-2 px-4 text-gray-700 hover:bg-primary/10 rounded"
            @click="goToContact; mobileMenuOpen = false"
          >联系协会</a>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { api } from '../api'

export default {
  name: 'AppHeader',
  data() {
    return {
      mobileMenuOpen: false,
      visitorCount: 0, // 默认值作为后备
      isLoggedIn: false,
      showUserDropdown: false,
      dropdownTimer: null
    }
  },
  mounted() {
    this.updateVisitorCount()
    this.checkLoginStatus()
  },
  methods: {
    checkLoginStatus() {
      // 检查 localStorage 中是否有 token
      this.isLoggedIn = !!localStorage.getItem('token')
    },
    async updateVisitorCount() {
      try {
        // 检查是否已经访问过
        const today = new Date().toISOString().split('T')[0]
        const visitedKey = `visitorCount_${today}`

        // 尝试获取最新访问量
        const count = await api.getDisplayCount(1)
        this.visitorCount = count

        // 如果今天还没有增加过计数，则增加计数
        if (!localStorage.getItem(visitedKey)) {
          await api.incrementDisplayCount(1)
          // 更新显示的计数
          this.visitorCount = count + 1
          // 标记今天已经访问过
          localStorage.setItem(visitedKey, 'true')
        }
      } catch (error) {
        console.error('更新访问量失败:', error)
        // 保留默认值
      }
    },
    handleLogin() {
      this.$router.push('/login')
    },
    handleLogout() {
      // 清除 localStorage 中的 token
      localStorage.removeItem('token')
      // 更新登录状态
      this.isLoggedIn = false
      // 隐藏下拉菜单
      this.showUserDropdown = false
      // 可以添加一个提示
      alert('已成功登出')
    },
    goToUserConsole() {
      // 预留：跳转到用户控制台
      alert('将跳转到用户控制台')
      // 未来可以修改为：this.$router.push('/user/console')
    },
    showDropdown() {
      // 清除之前的定时器
      if (this.dropdownTimer) {
        clearTimeout(this.dropdownTimer)
        this.dropdownTimer = null
      }
      // 显示下拉菜单
      this.showUserDropdown = true
    },
    hideDropdownWithDelay() {
      // 设置0.5秒延迟关闭
      this.dropdownTimer = setTimeout(() => {
        this.showUserDropdown = false
        this.dropdownTimer = null
      }, 500)
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    scrollToNews() {
      // 平滑滚动到新闻区块
      const newsSection = document.getElementById('news');
      if (newsSection) {
        newsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    goToNews() {
      if (this.$route.path === '/') {
        // 在首页时，滚动到新闻区块
        this.scrollToNews();
      } else {
        // 在其他页面时，跳转到通知列表页
        this.$router.push('/notices');
      }
    },
    goToServices() {
      if (this.$route.path === '/') {
        // 在首页时，滚动到服务区块
        const servicesSection = document.getElementById('services');
        if (servicesSection) {
          servicesSection.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // 在其他页面时，跳转到服务列表页
        this.$router.push('/services');
      }
    },
    goToAbout() {
      if (this.$route.path === '/') {
        // 在首页时，滚动到关于区块
        const aboutSection = document.getElementById('about');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // 在其他页面时，跳转到首页
        this.$router.push('/');
      }
    },
    goToBranches() {
      if (this.$route.path === '/') {
        // 在首页时，滚动到分支机构区块
        const branchesSection = document.getElementById('branches');
        if (branchesSection) {
          branchesSection.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // 在其他页面时，跳转到首页
        this.$router.push('/');
      }
    },
    goToMembers() {
      if (this.$route.path === '/') {
        const membersSection = document.getElementById('members');
        if (membersSection) {
          membersSection.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            const membersSection = document.getElementById('members');
            if (membersSection) {
              membersSection.scrollIntoView({ behavior: 'smooth' });
            }
          });
        });
      }
    },
    goToContact() {
      if (this.$route.path === '/') {
        // 在首页时，滚动到联系协会区块
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // 在其他页面时，跳转到首页
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
.nav-item {
    position: relative;
    padding: 10px 8px;
    color: #6b7280;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    white-space: nowrap;
    font-size: 14px;
}

.nav-item:hover {
    color: #4B60E7;
    background-color: #f3f4f6;
    border-radius: 4px;
}

.nav-item::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background-color: #4B60E7;
    transition: all 0.3s ease;
    transform: translateX(-50%);
}

.nav-item:hover::after {
    width: 80%;
}
.user-avatar {
  position: relative;
}

.user-dropdown {
  display: block;
}

.user-dropdown button {
  transition: all 0.2s ease;
}

.user-dropdown button:hover {
  background-color: #f3f4f6;
}
</style>
